import { graphql, Link } from 'gatsby';
import React from 'react';
import LitStructuredText from './generic/LitStructuredText';

const ModularHeadingPargraphButton = ({ data }) => {
  const {
    heading,
    paragraph,
    buttonText,
    buttonPath,
    backgroundColor,
    idContent,
  } = data;
  return (
    <div
      className={`modular-heading-paragraph-button-container ${backgroundColor} modular-padding-large `}
      id={`${idContent}`}
    >
      <div className="modular-text-center modular-global-width">
        <div className="modular-heading-third modular-heading-secondary">
          <LitStructuredText data={heading} basic />
        </div>
        <div className="modular-p">
          <LitStructuredText data={paragraph} basic />
        </div>
        <Link
          to={buttonPath}
          className={`${
            backgroundColor === 'White' ? 'button' : 'button-blue'
          }`}
        >
          {buttonText}
        </Link>
      </div>
    </div>
  );
};

export default ModularHeadingPargraphButton;

export const fragment = graphql`
  fragment ModularHeadingParagraphButton on DatoCmsHeadingParagraphButton {
    internal {
      type
    }
    heading {
      value
    }
    paragraph {
      value
    }
    buttonText
    buttonPath
    backgroundColor
    idContent
  }
`;
